import { AuthApi } from "../../Api";
import {
  GET_APP_NAVIGATION_REQUEST,
  GET_APP_NAVIGATION_SUCCESS,
  GET_APP_NAVIGATION_FAILURE
} from "../../Constants";

function requestAppNavigation() {
  return {
    type: GET_APP_NAVIGATION_REQUEST,
    isFetching: true
  };
}

function appNavigationSuccess(appData) {
  return {
    type: GET_APP_NAVIGATION_SUCCESS,
    isFetching: false,
    isAuthenticated: true,
    ssoId: appData.empId,
    appData
  };
}

function appNavigationError(errorMessage) {
  return {
    type: GET_APP_NAVIGATION_FAILURE,
    isFetching: false,
    errorMessage
  };
}

export const getAppNavigation = ssoId => dispatch => {
  dispatch(requestAppNavigation());

  AuthApi.getAppsNavigation(ssoId)
    .then(res => {
      if (res.reason) throw new Error(res.reason);
      dispatch(appNavigationSuccess(res));
    })
    .catch(err => dispatch(appNavigationError(err)));
};
